// extracted by mini-css-extract-plugin
export default {"item":"ConnectedVariationsColItem_item__LyQBR","item_disConnected":"ConnectedVariationsColItem_item_disConnected__Fc-Q2"};